export const extractRounds = <T extends { round?: string }>(matches: T[]) => {
  const rounds = new Set<string>();

  matches.forEach(match => {
    if (match.round) {
      rounds.add(match.round);
    }
  });

  return Array.from(rounds)
    .sort() // Ordenar alfabéticamente
    .map(round => ({
      value: round,
      label: round.charAt(0).toUpperCase() + round.slice(1)
    }));
};
